import { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login_reg.css";
import toastError from "_hooks/toast";
import { forgotPassword } from "_services/userApi";
import LoadingOverlay from "_components/overlay/LoadingOverlay";

export { ForgotPassword };

function ForgotPassword() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [username, setUsername] = useState("");
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (username.length<1) {
      setError("Please enter a valid Username.");
      return;
    }
    setLoader(true)
    setError("");
    const resp = await forgotPassword(username)
    if (resp?.success) {
        setSuccess(true)
    }
    setLoader(false)
  };

  return (
    <section className="login-sec d-flex align-center justify-center relative">
      <div className="login-body relative">
        <div className="l-logo relative">
          <img src="/images/login-logo.svg" alt="" />
        </div>
        {!success ? (
          <div className="login-box relative d-flex flex-col justify-between">
            <h5 className="d-flex justify-center mb-3">Forgot your Password</h5>
            <p className="text-center mb-1">
              Please confirm the registered username to send the password
              reset link
            </p>
            <form className="relative" onSubmit={handleSubmit}>
              <div className="form-group relative d-flex flex-col-reverse">
                <input
                  name="username"
                  type="text"
                  className="form-control"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <label className="relative d-flex justify-between align-center">
                  Username
                </label>
              </div>
              {error && <span className="error">{error}</span>}
              <div className="form-btn-part relative d-flex flex-col ">
                <button className="btns login-form-btn" type="submit">
                  Request reset link
                </button>
                <Link to="/account/login" className="btns back-to-login-btn">
                  Back to Login
                </Link>
              </div>
            </form>
          </div>
        ) : (
          <div className="login-box relative d-flex flex-col justify-center align-items-center">
            <p  className="text-center mb-1"> Success! A reset link has been sent to your email.</p>
            <p  className="text-center mb-4"> (Please check your span folder also.)</p>
              <div className="form-btn-part relative d-flex flex-col">
            <button
              className="btns login-success-btn"
              onClick={() => navigate("/account/login")}
            >
              Back to Login
            </button>
          </div>
          </div>
        )}
      </div>
      {loader && <LoadingOverlay/>}
    </section>
  );
}
